/*
 * @Author: 码上talk|RC
 * @Date: 2021-04-26 11:40:02
 * @LastEditTime: 2021-08-28 21:39:54
 * @LastEditors: 码上talk|RC
 * @Description:
 * @FilePath: /m/src/model/entity.class.js
 * @微信:  13680065830
 * @邮箱:  3189482282@qq.com
 * @oops: Just do what I think it is right
 */
import { Request } from './request';
import { formToolkit } from './form-toolkit';
import collection from './collection';

const _ = require('lodash');
class Entity {
  _tableField = []
  request = null
  _raw = null
  constructor (entity, { _tableField }) {
    this._tableField = _tableField;
    for (const i in _tableField) {
      if (entity && _tableField[i].isEntity) {
        const v = _.get(entity, i);
        this[i] = Array.isArray(v) ? v.map(j => new collection[_tableField[i].type](j)) : new collection[_tableField[i].type](v);
        continue;
      }
      this[i] = entity ? this._fieldDo(entity, i) : _.get(_tableField, `${i}.default`);
      this._raw = entity;
    }
  }

  _fieldDo (entity, i) {
    if (!this._tableField[i].do) {
      return _.get(entity, i);
    }
    const { parse } = this._tableField[i].do;
    if (parse) {
      return JSON.parse(_.get(entity, i));
    }
  }

  static filter (s, key) {
    for (let i = 0; i < this._options[s].length; i++) {
      if (this._options[s][i].value === key) {
        return this._options[s][i].label;
      }
    }
  }

  static sendApi (method, form = { params: {}, data: {} }) {
    const { app, domain } = this._requestConfig;
    return new Request().do(app, domain, method, form);
  }

  static formUtil () {
    return {
      generator: (module, type) => {
        const f = _.get(this._form, `${module}.${type}`);
        for (const i in f) {
          f[i] = Object.assign(f[i], { _validator: { ok: true, msg: '' } });
        }
        return _.cloneDeep(f);
      },
      validate: (json) => {
        return formToolkit.validate(json);
      },
      fill: (f, json, config) => {
        for (const i in f) {
          f[i] = Object.assign(f[i], { _validator: { ok: true, msg: '' } });
        }
        return formToolkit.fill(f, json, config);
      }
    };
  }
}

export default Entity;
